import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuoteSettingsStore } from "@/store/quoteSettingsStore";
import { useLineCustomFieldsExpandStore } from "@/store/lineCustomFieldsExpandStore";

/**
 * Sticky toggle that expands or collapses every line item's custom field
 * section at once. Renders nothing when no line-item custom fields are
 * configured. Must be placed inside the vertical scroll container (not inside
 * the table's horizontal-overflow wrapper) so `sticky` pins it while scrolling.
 */
export function ExpandCustomFieldsToggle() {
  const lineCustomFieldsSchema = useQuoteSettingsStore(
    (state) => state.settings?.lineItemCustomFieldsSchema ?? null,
  );
  const openCount = useLineCustomFieldsExpandStore((s) => s.openIds.size);
  const setAllExpanded = useLineCustomFieldsExpandStore((s) => s.setAll);

  const hasLineCustomFields =
    !!lineCustomFieldsSchema?.properties &&
    Object.keys(lineCustomFieldsSchema.properties).length > 0;

  if (!hasLineCustomFields) {
    return null;
  }

  const anyOpen = openCount > 0;

  return (
    <div className="sticky top-0 z-20 -mx-3 mb-1 flex justify-end bg-background/80 px-3 py-1.5 backdrop-blur supports-[backdrop-filter]:bg-background/60 sm:mx-0 sm:px-0">
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1.5 text-xs text-muted-foreground"
        onClick={() => setAllExpanded(!anyOpen)}
      >
        {anyOpen ? (
          <ChevronsDownUp className="h-3.5 w-3.5" />
        ) : (
          <ChevronsUpDown className="h-3.5 w-3.5" />
        )}
        {anyOpen ? "Collapse custom fields" : "Expand custom fields"}
      </Button>
    </div>
  );
}
